import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NumericFilterPipe {
  private twoDecimalFormat = '2.2-2';
  private fourDecimalFormat = '2.4-4';
  private twoDecimalFormatRound = '1.2-2';
  private boardValue = '';

  constructor(private decimalPipe: DecimalPipe) { }

  formatTwoDecimal(num: any) {
    if (!num) return "0.00";
    return this.decimalPipe.transform(num, this.twoDecimalFormat);
  }
  formatTwoDecimalRound(num: any) {
    if (!num) return "0.00";
    return this.decimalPipe.transform(num, this.twoDecimalFormatRound);
  }
  formatFourDecimal(num: any) {
    if (!num) return "0.0000";
    return this.decimalPipe.transform(num, this.fourDecimalFormat);
  }

  boardFilter(board: any) {
    //   if (!board) return ""; 
    //   if(board == "NR"){
    // 		this.boardValue = "Normal"
    // 	}else if (board == "SP"){
    // 		this.boardValue = "Spot"
    // 	}
    //   else if (board == "CR"){
    // 		this.boardValue = "Block Trade"
    // 	}else if(board == "OD"){
    // 		this.boardValue = "Oddlot"
    // 	}else if (board == "AL"){
    // 		this.boardValue = "All"
    // 	}
    //   return this.boardValue;
    // }
    // console.log("board",board);
    switch (board) {
      case "NR":
        this.boardValue = "Normal";
        break;

      case "SP":
        this.boardValue = "SPOT";
        break;

      case "OD":
        this.boardValue = "OdLot";
        break;

      case "BK":
        this.boardValue = "Bulk";
        break;

      case "AU":
        this.boardValue = "Auction";
        break;

      case "AT":
        this.boardValue = "ATB";
        break;

      case "SM":
        this.boardValue = "SME";
        break;
    }
    return this.boardValue;
  }
}
